import { render, staticRenderFns } from "./item-warehouses.vue?vue&type=template&id=1206c128&scoped=true"
import script from "./item-warehouses.vue?vue&type=script&lang=js"
export * from "./item-warehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206c128",
  null
  
)

export default component.exports